import React, { useContext } from 'react';
import { MealType, CreateMealType, BrandOption, BrandType } from 'utils/types';
import { MultiselectItem } from '@cokitchen/cokitchen-components/dist/form/multiselect/types';
import { MetadataType } from 'pages/create-brand/create-brand-metadata/types';

export type MealActionType = 'create' | 'edit';

type MealContextType = {
  formData: CreateMealType;
  setFormData: (item: CreateMealType) => void;
  loading: boolean;
  setLoading: (item: boolean) => void;
  meal: MealType;
  brandsList: MultiselectItem[];
  setBrandsList: (item: MultiselectItem[]) => void;
  categoryList: MultiselectItem[];
  setCategoryList: (item: MultiselectItem[]) => void;
  baseMealList: MultiselectItem[];
  brandLoading: boolean;
  setBrandLoading: (item: boolean) => void;
  selectedBrand: BrandOption[] | undefined;
  setSelectedBrand: (item: BrandOption[]) => void;
  resetForm: () => void;
  selectedKeywords: MetadataType[];
  setSelectedKeywords: (item: MetadataType[]) => void;
  selectedDescriptiveMetadata: MetadataType[];
  setSelectedDescriptiveMetadata: (item: MetadataType[]) => void;
  selectedBusinessMetadata: MetadataType[];
  setSelectedBusinessMetadata: (item: MetadataType[]) => void;
  newCategory: boolean;
  setNewCategory: (item: boolean) => void;
  selectedCategoryList: MultiselectItem[];
  setSelectedCategoryList: (item: MultiselectItem[]) => void;
  selectedBaseMeal: MultiselectItem[];
  setSelectedBaseMeal: (item: MultiselectItem[]) => void;
  mealImage: File[] | null;
  setMealImage: (item: File[]) => void;
  disabled: boolean;
  setDisabled: (item: boolean) => void;
  uploading?: boolean;
  setUploading?: (item: boolean) => void;
  allBrands: BrandType[];
  setAllBrands: (item: BrandType[]) => void;
};

export const MealContext = React.createContext({} as MealContextType);

const useMealContext = () => {
  const context = useContext(MealContext);
  return context;
};

export default useMealContext;
